import styled from "styled-components";

const SCSkills = styled.div`
  display: flex;
  justify-content: space-between;
  width: 245px;
  padding: 20px 0px;
`;

export {
  SCSkills
};
